import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminPackagesTableColumns";
import moment from "moment-jalaali";
import DeletePackage from "@general/deletePackage";

function PackagesTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
  onDataUpdate,
}) {
  const [tableData, setTableData] = useState([]);
  const { getPackagesCount: count, getPackages: packages } = data;
  useEffect(() => {
    const initialTableData = [];
    packages.map((p) => {
      const {
        id,
        name,
        createdAt,
        category,
        packageType,
        description,
        sessions,
        amountRial,
        days,
        product,
      } = p;
      initialTableData.push({
        key: id,
        name,
        category,
        packageType,
        amountRial: amountRial.toLocaleString(),
        daysOrSessions:
          packageType === "WORK_SPACE"
            ? `${days} روز`
            : packageType === "MEETING_ROOM"
            ? `${sessions} جلسه`
            : "-",
        product: product.name,
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        description,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id)}>
              <EyeOutlined />
            </a>
            |
            <DeletePackage id={id} name={name} onDeletePackage={onDataUpdate}>
              <a>
                <DeleteOutlined />
              </a>
            </DeletePackage>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [packages]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 800 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default PackagesTable;
